<template>
    <div>
        <div class="text-nowrap mb-2" v-for="attachment in value" :key="attachment">
            <a class="mr-2" @click="onRemove(attachment)"><i class="fa fa-trash"></i></a>
            <button @click="onClick(attachment)" type="button" class="text-left" :title="attachment">{{ attachment | truncate(60) }}</button>
        </div>
        <br>
        <button class="btn btn-info float-right" @click="onPickFile">Ajouter un fichier</button>
        <input
            type="file"
            style="display: none"
            ref="fileInput"
            @change="onFilePicked($event)"
        />
    </div>
</template>

<script>
   import { abstractField } from "vue-form-generator";

   export default {
    mixins: [ abstractField ],
    methods: {      
        onClick(attachment) {
            this.schema.onClick.call(this, attachment, this);
        },
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked($event) {
            this.schema.onAdded.call(this, this.model, this.schema, $event, this);
            this.$refs.fileInput.value = null;
        },
        onRemove(attachment) {
            this.schema.onRemoved.call(this, attachment, this);
        },
    }
   };
</script>